export class EstadoDocumentModel{
    id: string;
    nombre: string;
    discriminador: string;
}
